"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('data-switching', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M22 8C22 10.2091 17.9706 12 13 12C8.02944 12 4 10.2091 4 8C4 5.79086 8.02944 4 13 4C17.9706 4 22 5.79086 22 8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M22 8C22 10.2091 17.9706 12 13 12C8.02944 12 4 10.2091 4 8V14C4 16.2091 8.02944 18 13 18C17.9706 18 22 16.2091 22 14V8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M22 14C22 16.2091 17.9706 18 13 18C8.02944 18 4 16.2091 4 14V20C4 22.2091 8.02944 24 13 24C17.9706 24 22 22.2091 22 20V14Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M22 8C22 10.2091 17.9706 12 13 12C8.02944 12 4 10.2091 4 8M22 8C22 5.79086 17.9706 4 13 4C8.02944 4 4 5.79086 4 8M22 8V14M4 8V14M22 14C22 16.2091 17.9706 18 13 18C8.02944 18 4 16.2091 4 14M22 14V20C22 22.2091 17.9706 24 13 24C8.02944 24 4 22.2091 4 20V14",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M44 28C44 30.2091 39.9706 32 35 32C30.0294 32 26 30.2091 26 28C26 25.7909 30.0294 24 35 24C39.9706 24 44 25.7909 44 28Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 28C44 30.2091 39.9706 32 35 32C30.0294 32 26 30.2091 26 28V34C26 36.2091 30.0294 38 35 38C39.9706 38 44 36.2091 44 34V28Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 34C44 36.2091 39.9706 38 35 38C30.0294 38 26 36.2091 26 34V40C26 42.2091 30.0294 44 35 44C39.9706 44 44 42.2091 44 40V34Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 28C44 30.2091 39.9706 32 35 32C30.0294 32 26 30.2091 26 28M44 28C44 25.7909 39.9706 24 35 24C30.0294 24 26 25.7909 26 28M44 28V34M26 28V34M44 34C44 36.2091 39.9706 38 35 38C30.0294 38 26 36.2091 26 34M44 34V40C44 42.2091 39.9706 44 35 44C30.0294 44 26 42.2091 26 40V34",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M32 6H38C40.2091 6 42 7.79086 42 10V16",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M16 42H10C7.79086 42 6 40.2091 6 38V32",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;